const deviceNow = () => Date.now() / 1000;

// Seconds the device clock is behind the server clock, measured when an expiry is received.
// Stored next to the expiry (and persisted with it) so a wrong device time can't end a session early.
export const getClockOffset = (serverTime, clientNow = deviceNow()) => {
  const serverSeconds = Number(serverTime);
  if (serverTime === '' || serverTime === null || serverTime === undefined || !Number.isFinite(serverSeconds)) {
    return 0;
  }
  return serverSeconds - clientNow;
};

// Converts a server-clock Unix expiry onto the device clock.
export const toClientExpiry = (expiry, clockOffset) => parseInt(expiry) - (Number(clockOffset) || 0);

export const isSessionActive = (expiry, clockOffset, clientNow = deviceNow()) => clientNow < toClientExpiry(expiry, clockOffset);
